import React from 'react';
import { useRouteError } from 'react-router-dom';

import { parseErrors } from "./parse_errors"
import type { GetUsername, HasLoggedIn, SentryConfig } from "./common"



interface IProps<T extends HasLoggedIn> {
  useLogin: () => T,
  get_username: GetUsername<T>,
  sentry_config: SentryConfig,
}


const APIErrorCatcherFunctional = <T extends HasLoggedIn,>({ useLogin, get_username, sentry_config }: IProps<T>) => {
  const login = useLogin();
  const error = useRouteError() as Error;
  const { block, dettaglio } = parseErrors(error, login, get_username, sentry_config);
  return (
    <div className="container">
      <h1 className="page-header">{block}</h1>
      <p>{"È molto probabile ci sia già arrivata una email riguardo questo incidente, ma puoi comunque segnalarcelo." +
        "Prova a ricaricare la pagina per risolvere il problema. Se persiste, contattaci. Ecco i dettagli dell'errore:"}</p>
      {dettaglio}
    </div>
  );

}

export default APIErrorCatcherFunctional
